let events: { [x: string]: any; };

// 注册
export const on = (name: string, callback: Function) => {
  events[name] = callback;
}
//执行
export const emit = (name: string, data?: any) => {
  try {
    let callbacks = events[name];
    callbacks(data)
  } catch (error) {}
}
export const remove = (name: string) => {
  // let callbacks = events[name];
  // callbacks(data)
}

